import React from 'react'

import { Container } from '../../components/Bootstrap'
import Hero from '../../components/Hero'
import Layout from '../../components/Layout'
import Navigation from '../../components/Navigation'
import Summary from '../../components/Summary'
import TagCloud from '../../components/TagCloud'

import { bold } from '../../styles'

const data = [
  { text: 'independent', size: 1.6 },
  { text: 'living', size: 1.6 },
  { text: 'independently', size: 1 },
  { text: 'promote', size: 1.7 },
  { text: 'new skills', size: 1 },
  { text: 'resource', size: 1.4 },
  { text: 'make', size: 1.3 },
  { text: 'services', size: 1.8 },
  { text: 'help', size: 1.3 },
  { text: 'living', size: 2.6 },
  { text: 'empower', size: 1.8 },
  { text: 'people', size: 2.9 },
  { text: 'disabilities', size: 1.6 },
  { text: 'run', size: 1.3 },
  { text: 'provides', size: 0.9 },
  { text: 'CILT', size: 1.8 },
  { text: 'individuals', size: 1 },
  { text: 'community', size: 1.8 },
  { text: 'organization', size: 0.9 },
  { text: 'information', size: 1.7 },
]

const ConsumersThree = () => (
  <Layout>
    <Hero>
      <h1>Question 3</h1>
      <p className={bold}>In your own words, what is the purpose of Centre for Independant Living in Toronto (CILT)?</p>
    </Hero>
    <Container>
      <Navigation prev="/consumers/2" next="/consumers/4" />
      <TagCloud words={data} />
	  <Summary>The word cloud shows that the words most often associated with CILT are "people", "living" and “community” with the other words in the cloud being used less often.</Summary>
    </Container>
  </Layout>
)

export default ConsumersThree
